module.exports = __webpack_public_path__ + "static/media/icon-meter.a2609991.png";